import { render } from "./OnboardingForm.vue?vue&type=template&id=4bfcc45a&scoped=true"
import script from "./OnboardingForm.vue?vue&type=script&lang=js"
export * from "./OnboardingForm.vue?vue&type=script&lang=js"

import "./OnboardingForm.vue?vue&type=style&index=0&id=4bfcc45a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bfcc45a"]])

export default __exports__